import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';

/**
 * Consumes and clears the current MFA token from the client state.
 *
 * This function retrieves the MFA token obtained from a successful MFA authentication,
 * and removes it from the client, to prevent it from being used again.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns The MFA token that was consumed.
 * @throws Error if no MFA token is found.
 */
export const consumeMfaToken = (client = getDefaultClient()) => {
  const core = getCore(client);

  const mfaToken = core.state.get().mfaToken;

  assertDefined(mfaToken, 'No MFA token found');

  core.state.set({
    mfaToken: null,
  });

  return mfaToken;
};
